import type { Overrides } from '../../themes/ThemeTypes';

import colors from './colors';
import fonts from './fonts';

// To be filled in with Utilita theme overrides
const overrides: Overrides = {
  '.amplify-sign-out button': {
    border: `1px solid ${colors.primary}`,
    background: colors.white,
    fontWeight: fonts.fontWeights.medium,
    color: colors.primary,
    fontSize: '14px',
    padding: '8px 16px',
  },
  '.custom-switch': {
    paddingLeft: '2.5rem',
  },
  '${min.xl}': {
    '.container, .container-sm, .container-md, .container-lg, .container-xl': {
      maxWidth: '1140px',
    },
  },
};

export default overrides;
